import React from 'react';
import styled from '../../theme/styled';

import oh from 'output-helpers';

//Cards
interface CardProps {
    title: string;
    price: string;
    price_fine_print: string;
    features: string[];
    main: boolean;
}

const CardList = styled.ul`
    font-family: 'Asap', sans-serif;
    color: #ffffff;
    text-align: left;
    width: 100%;
    padding: 0;
    display: flex;
    flex-flow: row wrap;
    justify-content: center;
`;

const CardContainer = styled.li`
    display: flex;
    flex-direction: column;
    width: 50%;
    flex-basis: 500px;
    .plan {
        margin: 10px;
        position: relative;
        overflow: hidden;
        box-shadow: 0 0 5px rgba(0, 0, 0, 0.3);
        background-color: white;
        color: ${props => props.theme.colors.dark[1]};
        border-radius: 8px;
    }
    & * {
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        -webkit-transition: all 0.25s ease-out;
        transition: all 0.25s ease-out;
    }
    header {
        padding-bottom: 20px;
    }
    .plan-title {
        background-color: ${props => props.theme.colors.brand[3]};
        color: white;
        position: relative;
        margin: 0;
        padding: 20px 20px 0;
        font-weight: bold;
    }
    .plan-title:after {
        position: absolute;
        content: '';
        top: calc(100% - 1px);
        left: 0;
        width: 100%;
        height:30px;
        border-top: 1px solid ${props => props.theme.colors.brand[3]};
        background-color: ${props => props.theme.colors.brand[3]};
        -webkit-clip-path: polygon(0 0, 0 100%, 110% 0);
        clip-path: polygon(0 0, 0 100%, 110% 0);
    }
    .plan-cost {
        padding: 40px 20px 10px;
        text-align: right;
    }
    .plan-cost-fine-print {
        padding: 0 20px 0 0;
        font-size: 14px;
        color: ${props => props.theme.colors.dark[3]};
        text-align: right;
    }
    .plan-price {
        font-weight: 600;
        font-size: 2em;
    }
    .plan-type {
        opacity: 0.8;
        font-size: 0.7em;
        text-transform: uppercase;
    }
    .plan-features {
        font-size: 0.9em;
        padding: 0 0 20px;
        margin: 0;
        list-style: outside none none;
    }
    .plan-features li {
        padding: 12px 5%;
    }
    .plan-select {
        border-top: 1px solid rgba(0, 0, 0, 0.2);
        padding: 20px;
        text-align: center;
    }
    .plan-select a {
        background-color: ${props => props.theme.colors.brand[3]};
        color: #ffffff;
        text-decoration: none;
        padding: 20px 20px;
        width: 100%;
        font-size: 0.8em;
        line-height: 20px;
        font-weight: 600;
        border-radius: 9999px;
        display: inline-block;
    }
    .plan-select a:hover {
        background-color: ${props => props.theme.colors.dark[1]};
    }
    .featured {
        border-color: #331926;
        box-shadow: 0 0 25px rgba(0, 0, 0, 0.4);
        z-index: 1;
        border-radius: 8px;
}
`;

export class Card extends React.Component<CardProps>{
    public static defaultProps = {
        main: false,
        price_fine_print: "",
    };

    render() {
        return (
        <CardContainer>
            <div className={this.props.main ? "plan featured" : "plan"}>
                <header>
                    <h4 className="plan-title">{this.props.title}</h4>
                    <div className="plan-cost"><span className="plan-price">{this.props.price}</span><span className="plan-type">/{oh.translate("month")}</span></div>
                    <div className="plan-cost-fine-print">{this.props.price_fine_print}</div>
                </header>
                <ul className="plan-features">
                    {this.props.features.map(item => <li key={item}>{item}</li>)}
                </ul>
                <div className="plan-select"><a href={"mailto:christian.malmstrom@allbinary.se?subject=" + oh.translate("email_subject") + " - " + this.props.title}>{oh.translate("pricing_button")}</a></div>
            </div>
        </CardContainer>);
    }
}

export class CardRow extends React.Component {
    render() {
        return (<CardList>{this.props.children}</CardList>);
    }
}


// WEBPACK FOOTER //
// ./src/components/base/Cards.tsx